import { Schedule, ListService } from "@/types";

export const ScheduleService: ListService<Schedule> = {};
